import { put, call, takeLatest, takeEvery, select } from 'redux-saga/effects';
import {
  USER_PROFILE_SUCCESSED,
  USER_PROFILE_FAILED,
  USER_PROFILE_REQUESTED,
  USER_PROFILE_UPDATE_SUCCESSED,
  USER_PROFILE_UPDATE_FAILED,
  USER_PROFILE_UPDATE_REQUESTED,
  USER_CHANGE_PASSWORD_SUCCESSED,
  USER_CHANGE_PASSWORD_FAILED,
  USER_CHANGE_PASSWORD_REQUESTED,
  USER_GOOGLE_QR_REQUESTED,
  USER_GOOGLE_QR_SUCCESSED,
  USER_GOOGLE_QR_FAILED,
  USER_GOOGLE_AUTH_REQUESTED,
  USER_GOOGLE_AUTH_SUCCESSED,
  USER_GOOGLE_AUTH_FAILED,
  SHOW_LOADER,
  HIDE_LOADER,
} from '../../constants/actionTypes';
import {
  userChangePasswordSaga,
  userProfileSaga,
  userProfileUpdateSaga,
  getGoogleQrCodeSaga,
  googleAuthProfileSaga,
} from '../../api/userSaga';
import { showToastError, showToastLoader, showToastSuccess } from '../../utils/toasts';

export function* watchUserProfileList(action) {
  try {
    yield put({ type: SHOW_LOADER });
    const response = yield call(userProfileSaga);
    if (response.success) {
      yield put({ type: USER_PROFILE_SUCCESSED, data: response });
      localStorage.setItem('profileFetched', 1);

      const updatedPermissions = response?.data?.access;
      const storedPermissions = (localStorage.getItem("access") && localStorage.getItem("access") !== 'undefined')
        ? JSON.parse(localStorage.getItem("access")) : [];

      let difference = updatedPermissions
        .filter(x => !storedPermissions.includes(x))
        .concat(storedPermissions.filter(x => !updatedPermissions.includes(x)));

      if (difference?.length > 0) {
        localStorage.setItem('access', JSON.stringify(updatedPermissions));
      }
    } else {
      yield put({ type: USER_PROFILE_FAILED, data: null });
    }
    if (!action.isDashbord) {
      yield put({ type: HIDE_LOADER });
    }
  } catch (err) {
    yield put({ type: USER_PROFILE_FAILED, data: err?.response?.data?.data });
  } finally {
    yield put({ type: HIDE_LOADER });
  }
}

export function* watchGetGoogleQr(action) {
  try {
    const response = yield call(getGoogleQrCodeSaga);
    if (response.success) {
      yield put({ type: USER_GOOGLE_QR_SUCCESSED, data: response });
    } else {
      yield put({ type: USER_GOOGLE_QR_FAILED, data: null });
    }
  } catch (err) {
    yield put({
      type: USER_GOOGLE_QR_FAILED,
      data: err?.response?.data?.data,
    });
  }
}

export function* watchChangePassword(action) {
  try {
    const response = yield call(userChangePasswordSaga, action.payload);
    if (response.success) {
      yield put({ type: USER_CHANGE_PASSWORD_SUCCESSED, data: response });
    } else {
      yield put({ type: USER_CHANGE_PASSWORD_FAILED, data: null });
    }
  } catch (err) {
    yield put({
      type: USER_CHANGE_PASSWORD_FAILED,
      data: err?.response?.data?.data,
    });
  }
}

export function* watchGoogleAuthProfile(action) {
  const loaderHandle = showToastLoader('Updating google authentication...')
  try {
    const response = yield call(googleAuthProfileSaga, action.payload);
    if (response.success) {
      showToastSuccess('Google authentication updated', loaderHandle)
      yield put({ type: USER_GOOGLE_AUTH_SUCCESSED, data: response });
    } else {
      showToastError(response?.data?.message, loaderHandle)
      yield put({ type: USER_GOOGLE_AUTH_FAILED, data: null });
    }
  } catch (err) {
    yield put({
      type: USER_GOOGLE_AUTH_FAILED,
      data: err?.response?.data?.data?.message,
    });
    showToastError(err?.response?.data?.data?.message, loaderHandle)
  }
}

export function* watchUserProfileUpdate(action) {
  const loaderHandle = showToastLoader('Updating profile...')
  try {
    const response = yield call(userProfileUpdateSaga, action.payload);
    if (response.success) {
      const userProfile = yield select(state => state.userStore?.userProfile);

      let tempProfile = { ...userProfile };
      tempProfile.data.profile = response.data;

      yield put({ type: USER_PROFILE_UPDATE_SUCCESSED, data: tempProfile });
      showToastSuccess('Profile updated', loaderHandle);
      action?.callBack();
    } else {
      showToastError(response?.data?.message, loaderHandle)
      yield put({ type: USER_PROFILE_UPDATE_FAILED, data: null });
    }
  } catch (err) {
    showToastError(err?.response?.data?.data, loaderHandle)
    yield put({
      type: USER_PROFILE_UPDATE_FAILED,
      data: err?.response?.data?.data,
    });
  }
}

export default function* watcher() {
  yield takeEvery(USER_PROFILE_REQUESTED, watchUserProfileList);
  yield takeLatest(USER_PROFILE_UPDATE_REQUESTED, watchUserProfileUpdate);
  yield takeLatest(USER_GOOGLE_AUTH_REQUESTED, watchGoogleAuthProfile);
  yield takeLatest(USER_GOOGLE_QR_REQUESTED, watchGetGoogleQr);
  yield takeLatest(USER_CHANGE_PASSWORD_REQUESTED, watchChangePassword);
}
